<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      style="overflow: visible"
      @md-clicked-outside="closeDialog"
    >
      <div class="custom-header">
        <md-dialog-title>Документ об оплате</md-dialog-title>
        <md-button
          class="md-button md-just-icon md-simple"
          @click="closeDialog"
        >
          <i class="material-icons ">close</i>
        </md-button>
      </div>
      <template v-if="isPDF">
        <embed
          class="pdf-iframe"
          type="application/pdf"
          :src="receiptUrl + '#toolbar=1&navpanes=1&scrollbar=0'"
          width="100%"
        >
      </template>
      <template v-else>
        <md-progress-bar
          v-if="loader"
          class="md-warning"
          md-mode="buffer"
        ></md-progress-bar>
        <div class="custom-content" v-html="receiptData"></div>
      </template>
    </md-dialog>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";
export default {
  name: "DialogShowReceipt",
  data() {
    return {
      show: false,
      loader: false,
      receiptData: ""
    };
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    receiptUrl: {
      type: String,
      default: ""
    },
    isPDF: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!this.isPDF) {
      this.fetchReceiptData();
    }
  },
  computed: {},
  methods: {
    fetchReceiptData() {
      this.loader = true;
      const host = config.site.host;
      axios.get(`${host}${this.receiptUrl}`).then(res => {
        this.receiptData = res.data;
        this.loader = false;
      });
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="scss" scoped>
.pdf-iframe {
  width: 600px;
  height: 800px;
  max-height: unset;
  border: 0;
  @media (max-width: 600px) {
    height: 100vh;
  }
}
.md-dialog {
  max-height: 100%;
}
@media (min-width: 600px) {
  .md-dialog-fullscreen {
    transform: translate(-49%, -51%) !important; // fix blured text in md-dialog
  }
}
.custom-content {
  overflow-x: scroll !important;
}
</style>
